import React, { useEffect, useState, useRef } from "react";
import { useAuthStore } from "@/stores/authStore";
import { useNotificationStore } from "@/stores/notificationStore";
import LogoutTemplate from "@/components/templates/LogoutTemplate";
import LogoutContent from "@/components/organisms/LogoutContent";

function Logout() {
  const { logout } = useAuthStore();
  const { showNotification } = useNotificationStore();
  const [status, setStatus] = useState("loading");
  const isLoggingOut = useRef(false);

  useEffect(() => {
    const performLogout = async () => {
      if (isLoggingOut.current) {
        return;
      }

      isLoggingOut.current = true;
      setStatus('processing');

      try {
        await logout();
        setStatus('success');
        
        setTimeout(() => {
          window.location.replace('/login');
        }, 2000);
        
      } catch (error) {
        setStatus('error');
        setError('Error al cerrar sesión');
        
        setTimeout(() => {
          window.location.replace('/login');
        }, 3000);
      }
    };

    performLogout();

    return () => {
      isLoggingOut.current = false;
    };
  }, [logout, showNotification]);

  return (
    <LogoutTemplate status={status}>
      <LogoutContent status={status} />
    </LogoutTemplate>
  );
}

export default Logout;
